export default __webpack_public_path__ + "static/100--stacked-bar-c7d344cc524b88151ae160f940bccf50.png";